import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ITableOptions } from '@modeso/aumico-lib-core-fe';
import { GetTemplatesNamesAndIdsDto } from '@modeso/types__aumico-lib-templates-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'app-ar-template-taxonomy-component',
    templateUrl: './ar-template-taxonomy.component.html',
    styleUrls: ['./ar-template-taxonomy.component.scss'],
})
export class ArTemplateTaxonomyComponent {
    public options: ITableOptions | undefined;
    public filterSubject = new BehaviorSubject<string>(undefined);

    @Input() data: GetTemplatesNamesAndIdsDto[] = [];
    @Input() savedSelectionId: string;

    @Output() onTaxonomySelected = new EventEmitter<string>();

    constructor() {
        this.options = {
            columns: [
                {
                    name: 'select',
                    flex: 10,
                },
                { name: 'Template Name', type: 'text', property: 'name', flex: 50 },
            ],
            singleSelectionProperty: '_id',
        };
    }

    public applyFilter(searchValue: string) {
        this.filterSubject.next(searchValue);
    }

    private onSingleRowSelection(rowId: string, checked: boolean): void {
        if (checked == true) {
            this.onTaxonomySelected.emit(rowId);
        } else {
            this.onTaxonomySelected.emit(null);
        }
    }
}
